import React, { Component } from 'react';

class Tab3 extends Component {
	render() {
		return (
			<div className="columns" id="faq">
				<div className="section column">
					<div className="content faq-content">
						<div className="columns">
							<div className="column ">
								<div className="title is-4">
									<h4> Kebijakan Privasi </h4>
								</div>
								<p>
									Kebijakan Privasi berikut ini menjelaskan bagaimana Kami mengumpulkan, menyimpan,
									menggunakan, memindahkan, mengungkapkan dan melindungi informasi pribadi Anda yang
									dapat diidentifikasi yang diperoleh melalui Aplikasi kami (sebagaimana didefinisikan
									di bawah). Mohon Anda membaca Kebijakan Privasi ini dengan seksama untuk memastikan
									bahwa Anda memahami bagaimana ketentuan Kebijakan Privasi ini kami berlakukan.
								</p>
								<p>
									Kebijakan Privasi ini disertakan sebagai bagian dari Ketentuan Penggunaan kami.
									Kebijakan Privasi ini mencakup hal-hal sebagai berikut:
								</p>
								<ol type="1">
									<li>Definisi</li>
									<li>Informasi yang kami kumpulkan</li>
									<li>Penggunaan informasi yang kami kumpulkan</li>
									<li>Pemberian informasi yang kami kumpulkan</li>
									<li>Keamanan</li>
									<li>Perubahan atas Kebijakan Privasi ini</li>
									<li>Pengakuan dan persetujuan</li>
									<li>Penarikan Persetujuan dan Pemusnahan</li>
									<li>Berhenti menerima e-mail</li>
									<li>Cara untuk menghubungi kami</li>
								</ol>
								<strong>
									Penggunaan Anda atas Aplikasi dan layanan kami tunduk pada Ketentuan Penggunaan dan
									Kebijakan Privasi ini dan mengindikasikan persetujuan Anda terhadap Ketentuan
									Penggunaan dan Kebijakan Privasi tersebut.
								</strong>
								<br/>
								<h5>Definisi</h5>
								<ol type="1">
									<li>
										“Afiliasi” berarti (i) pihak pengendali dari; (ii) anak perusahaan dari; atau
										(iii) pihak yang berada dalam satu pengendalian dengan PT Deliv Technologies.
										<li>
											"Aplikasi" berarti suatu aplikasi piranti lunak dan/atau situs portal yang
											Kami kembangkan yang merupakan suatu sarana elektronik untuk (i) menemukan
											Layanan yang disediakan oleh pihak ketiga; (ii) mengelola penyediaan
											Layanan; dan/atau (iii) fungsi lainnya yang diperlukan untuk mendukung
											ekosistem Layanan.
										</li>
										<li>
											"Informasi Pribadi" berarti informasi mengenai Anda yang secara pribadi
											dapat diidentifikasi yang dikumpulkan melalui Aplikasi, seperti nama,
											alamat, tanggal lahir dan pekerjaan (apabila Anda adalah seorang individu),
											data dan dokumen identitas perusahaan (apabila Anda bukan seorang individu),
											nomor telepon, alamat surat elektronik (e-mail), perizinan dan/atau
											sejenisnya, dan informasi lain yang mungkin dapat mengidentifikasi Anda
											sebagai pengguna Aplikasi.
										</li>
										<li>
											"Kami" berarti PT Deliv Technologies, suatu perusahaan yang didirikan
											berdasarkan hukum Negara Republik Indonesia, dan/atau Afiliasi-nya.
										</li>
										<li>
											“Ketentuan Penggunaan” berarti syarat dan ketentuan atau prosedur standar
											operasi atau ketentuan lainnya sehubungan dengan masing-masing Aplikasi yang
											dikembangkan oleh AKAB dan/atau Afiliasi-nya (sebagaimana berlaku),
											sebagaimana dapat diubah atau ditambah dari waktu ke waktu oleh AKAB
											dan/atau Afiliasi-nya;
										</li>
										<li>
											"Layanan" berarti berbagai layanan yang ditawarkan Penyedia Layanan melalui
											Aplikasi, termasuk namun tidak terbatas pada pengantaran atau penjemputan
											untuk barang dan/atau orang, layanan pembelanjaan pribadi dan/atau layanan
											lainnya yang disediakan dari waktu ke waktu melalui Aplikasi.
										</li>
										<li>
											“Pelanggan” berarti pihak yang terdaftar sebagai pelanggan Aplikasi untuk
											menggunakan Layanan yang disediakan di dalam Aplikasi.
										</li>
										<li>
											"Penyedia Layanan" berarti pihak yang menyediakan Layanan melalui Aplikasi
										</li>
										<li>
											"Situs Web" berarti situs web kami di www.deliv.co.id atau situs lainnya
											yang secara resmi kami kembangkan guna mendukung ekosistem Layanan.
										</li>
									</li>
								</ol>
								<h5>Informasi yang Kami Kumpulkan</h5>

								<p>
									Kami mengumpulkan Informasi Pribadi tertentu dari Anda agar Aplikasi dapat
									menjalankan fungsinya baik untuk penggunaan Layanan (apabila Anda adalah Pelanggan)
									atau pengelolaan penyediaan Layanan (apabila Anda adalah Penyedia Layanan) atau
									fungsi lainnya yang diperlukan untuk mendukung ekosistem Layanan. Informasi Pribadi
									dapat Anda berikan secara langsung (sebagai contoh, saat Anda mendaftar sebagai
									pengguna Aplikasi) maupun terkumpul secara otomatis ketika Anda menggunakan
									Aplikasi. Ketika Anda mengunjungi Situs Web, administrator Situs Web akan memproses
									data teknis seperti alamat protokol internet (internet protocol address) Anda,
									halaman web yang pernah Anda kunjungi, browser internet yang Anda gunakan, halaman
									web yang sebelumnya/selanjutnya Anda kunjungi dan durasi setiap kunjungan/sesi yang
									memungkinkan Kami untuk mengirimkan fungsi-fungsi Situs Web. Sebagai tambahan, dalam
									beberapa hal, browser dapat menyarankan Anda agar mengaktifkan fungsi geo-location
									Anda untuk memungkinkan Kami memberikan Anda suatu pengalaman yang lebih baik dalam
									menggunakan internet dan/atau Aplikasi. Dengan data teknis ini
									administrator-administrator Situs Web dapat mengelola Situs Web, misalnya dengan
									menyelesaikan kesulitan-kesulitan teknis atau memperbaiki kemampuan akses
									bagian-baigan tertentu dari Situs Web. Dengan cara ini, Kami dapat memastikan bahwa
									Anda dapat (terus) menemukan informasi pada Situs Web dengan cara yang cepat dan
									sederhana.
								</p>
								<h5>Informasi yang Anda berikan secara langsung.</h5>
								<ol type="1">
									<li>
										Pada saat mendaftar pada Aplikasi, Anda akan memberikan kepada Kami Informasi
										Pribadi tertentu sesuai Ketentuan Penggunaan yang disyaratkan masing-masing
										jenis dan fungsi Aplikasi.
									</li>
									<li>
										Ketika Anda menggunakan Aplikasi untuk menggunakan atau mengelola suatu Layanan,
										Anda memberikan informasi pada kami sebagaimana relevan, seperti, apabila Anda
										adalah Pelanggan, jenis Layanan, lokasi penjemputan/pengantaran barang/jasa yang
										dipesan dan/atau total biaya transaksi Layanan, atau, apabila Anda adalah
										Penyedia Layanan, data pesanan dan data terkait pengelolaan Layanan, jumlah dana
										atas transaksi Layanan dan/atau data lainnya sebagai pendukung ekosistem
										Layanan. Ketika Anda menggunakan Aplikasi Kami, Kami juga akan memproses data
										teknis Anda seperti, internet protocol address, identitas (ID) perangkat
										internet atau alamat kontrol akses media (media access control address), dan
										informasi mengenai pabrikan, model, dan sistem operasi dari perangkat yang Anda
										gunakan untuk mengakses Aplikasi. Kami menggunakan data ini untuk memungkinkan
										Kami untuk mengirimkan fungsi-fungsi dari Aplikasi, menyelesaikan
										kesulitan-kesulitan teknis, menyediakan bagi Anda versi Aplikasi yang benar dan
										terkini serta untuk meningkatkan fungsi Aplikasi.
									</li>
									<li>
										Apabila Anda adalah Pelanggan, Kami akan meminta nomor telepon seseorang yang
										dapat dihubungi oleh Penyedia Layanan untuk melengkapi pesanan Anda ketika Anda
										menggunakan Aplikasi untuk menemukan suatu Layanan kurir instan, atau Layanan
										lainnya yang relevan. Anda harus mendapatkan persetujuan terlebih dahulu dari
										orang yang nomor teleponnya Anda berikan pada Kami untuk memberikan nomor
										teleponnya pada Kami dan untuk Kami memberikan nomor telepon tersebut kepada
										Penyedia Layanan.
									</li>
									<li>
										Apabila Anda adalah Penyedia Layanan, Kami akan meminta nomor telepon pihak yang
										dapat dihubungi oleh Pelanggan yang menggunakan Layanan. Anda harus memastikan
										bahwa persetujuan terlebih dahulu dari pemilik nomor tersebut telah didapatkan
										untuk Kami memperoleh nomor telepon tersebut dan memberikannya kepada Pelanggan.
									</li>
									<li>
										Sehubungan dengan fasilitas uang elektronik yang mungkin tersedia dalam
										Aplikasi, Kami akan mengumpulkan informasi terkait transaksi uang elektronik
										tersebut oleh Anda, termasuk namun tidak terbatas pada nama bank, nama pemegang
										rekening, nomor rekening dan jumlah dana yang ditransaksikan melalui fasilitas
										uang elektronik tersebut.
									</li>
									<li>
										Apabila Anda adalah Pelanggan, Anda dapat memberikan kode rujukan (referral
										code) kepada pihak lain melalui Aplikasi, dalam bentuk suatu pesan yang Kami
										siapkan untuk Anda kirimkan atau terbitkan melalui fasilitas pengiriman pesan
										elektronik atau melalui penyedia media sosial. Anda dapat mengubah kalimat pesan
										yang telah kami siapkan sebelum Anda mengirimkannya. Kami tidak akan
										mengumpulkan data pihak yang Anda kirimi pesan tersebut.
									</li>
								</ol>
								<h5>Informasi yang kami kumpulkan ketika anda menggunakan Aplikasi.</h5>
								<ol type="1">
									<li>
										Ketika Anda menggunakan Aplikasi melalui perangkat bergerak/mobile device Anda,
										Kami akan melacak dan mengumpulkan informasi geo-location secara real-time dan
										informasi lainnya yang relevan untuk menunjang efisiensi kinerja dan fungsi
										Aplikasi. Apabila Anda adalah Pelanggan, Kami menggunakan informasi ini untuk,
										di antaranya, memungkinkan Anda untuk melihat lokasi Penyedia Layanan, mengatur
										lokasi penjemputan dan/atau pengantaran dan mengirimkan informasinya kepada
										Penyedia Layanan yang diminta, serta untuk memantau pergerakan Penyedia Layanan
										yang diminta mendekat di suatu peta secara real-time. Apabila Anda adalah
										Penyedia Layanan, Kami menggunakan informasi geo-location untuk, di antaranya,
										memungkinkan Anda untuk melihat lokasi Pelanggan, barang/jasa, pengantaran atau
										penjemputan yang dipesan Pelanggan (sebagaimana relevan). Kami juga dapat
										menggunakan informasi geo-location secara real-time ini untuk memberikan
										bantuan, menyelesaikan kesulitan-kesulitan teknis atau usaha yang mungkin timbul
										pada saat Anda menggunakan Aplikasi. Anda dapat mematikan informasi pelacak
										geo-location pada tingkatan perangkat Anda untuk sementara waktu. Perangkat
										bergerak/mobile device Anda akan memberitahukan Anda ketika geo-location Anda
										dilacak dengan menampilkan simbol panah Global Positioning System (GPS).
									</li>
									<li>
										Informasi geo-location yang kami peroleh dari Penyedia Layanan berarti bahwa
										Kami juga mengumpulkan informasi pergerakan Anda (apabila Anda adalah Pelanggan)
										ketika Anda bepergian dengan dengan menggunakan Layanan dalam Aplikasi. Kami
										juga akan menggunakan informasi geo-location secara keseluruhan dan dalam bentuk
										tanpa nama untuk mendapatkan informasi statistik dan informasi pengelolaan untuk
										tujuan peningkatan fungsi Aplikasi.
									</li>
								</ol>
								<h5>Penggunaan Cookie</h5>
								<ol type="1">
									<li>
										Cookie adalah berkas data kecil yang ditempatkan browser Anda pada perangkat
										internet Anda. Dengan cookie, fitur aplikasi dan/atau situs web yang Anda akses
										dapat menyimpan informasi atau mengingat tindakan dan preferensi Anda dari waktu
										ke waktu.
									</li>
									<li>
										Sebagian besar browser internet mendukung cookie; namun Anda dapat mengatur
										browser yang Anda gunakan untuk menolak beberapa jenis cookie tertentu atau
										cookie spesifik. Di samping itu, Anda dapat menghapus cookie kapan saja.
									</li>
									<li>
										Kami menggunakan cookie untuk berbagai tujuan. Kami menggunakannya, misalnya,
										untuk mengingat preferensi penelusuran aman Anda, membantu Anda untuk
										menggunakan Layanan (apabila Anda adalah Pelanggan) atau mengelola Layanan
										(apabila Anda adalah Penyedia Layanan), dan melindungi data Anda.
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>
				<div className="column is-one-quarter section">
					<figure>
						<img src="/img/banner-gopoint-1.jpg" alt="" />
					</figure>
				</div>
			</div>
		);
	}
}

export default Tab3;
